module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@2x-cae1f2c9c501a5a784c9f4ef37a8ab3d.png";